module.exports = __webpack_public_path__ + "assets/img/f1.2421e267.jpg";